interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  actionText?: string;
  actionTo?: string;
}

import { Link } from "react-router-dom";

function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  actionText,
  actionTo,
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:mb-10 ${
        isCenter
          ? "items-center text-center"
          : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={`max-w-2xl ${isCenter ? "mx-auto" : ""}`}>
        {eyebrow && (
          <span className="mb-3 inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionText}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}

export default SectionHeading;